import React from 'react';
import { StapleTable, StapleTableBody } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { FormInstanceType } from 'types/formService';
import EmployerFormTableRow from '../EmployerFormTableRow';
import EmployerFormsTableHeader from '../EmployerFormsTableHeader';

interface Props {
  formInstances: FormInstanceType[];
  loading: boolean;
}

const EmployerFormsTable: React.FC<Props> = observer(({ formInstances, loading }) => {
  return (
    <StapleTable totalElements={formInstances.length} loading={loading}>
      <EmployerFormsTableHeader />
      <StapleTableBody>
        {formInstances.map((form) => (
          <EmployerFormTableRow key={form.id} formInstance={form} />
        ))}
      </StapleTableBody>
    </StapleTable>
  );
});

export default EmployerFormsTable;
